import React from "react";

// Style
import './Account.scss';
import "pages/Checkout/ShippingForm.scss";

// components
import Profile from "./pages/Profile/Profile";
import Address from "./pages/Addresses/Adresses";
import Tabs from "components/UiKit/Tabs";

export const Account: React.FC = () => {
  const tabs = [
    {
      url: "profile",
      label: "Profile",
      content: <Profile />
    },
    {
      url: "address",
      label: "Addresses",
      content: <Address />
    }
  ];

  return (
    <div className="account">
      <h1 className="account__title mb10">My account</h1>
      <p className="account__text mb40">You can update your information bellow</p>
      <div className="account__wrapper">
        <Tabs
          tabs={tabs}
          type="primary"
          defaultScreen="profile"
        />
      </div>
    </div>
  );
};

export default Account;
